import styled, { css } from 'styled-components';

import { overlay } from 'styled';

export const ModalStyles = css`
  .ant-modal-header {
    display: none !important;
  }

  .ant-modal-body {
    height: calc(100vh - 64px) !important;
    max-height: 680px !important;
    padding: 0px !important;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;

export const LeftWrapper = styled.div`
  width: 240px;
  height: 100%;

  border-right: 1px solid #efefef;

  display: flex;
  flex-direction: column;
`;

export const RightWrapper = styled.div`
  width: calc(100% - 240px);
  height: 100%;

  display: flex;
  flex-direction: column;
`;

export const BillingTypeWrapper = styled.div`
  height: calc(100% - 84px);
  overflow: scroll;
  overflow-x: hidden;

  padding: 0px 4px 12px 12px;

  display: flex;
  flex-direction: column;

  ${overlay}
`;

export const WrapperInfoTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 114px;
  padding: 24px;
  background: #26b75d5e;
  border-radius: ${props => props.theme.radius.md};
`;

export const WrapperSummary = styled.div`
  display: table;
  height: fit-content;
`;

export const RowInfo = styled.div<{
  width?: number;
  left?: number;
  right?: number;
  justify?: string;
}>`
  display: flex;
  position: relative;
  justify-content: ${p => (p.justify ? p.justify : 'flex-start')};
  width: ${props => (props.width ? `${props.width}px` : '100%')};
  height: fit-content;
`;

export const WrapperBorder = styled.div`
  width: fit-content;
  height: fit-content;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
`;

export const WrapperA4Border = styled.div`
  width: 860px;
  height: fit-content;

  background: #ffffff;

  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);

  padding: 15mm 15mm;
`;

export const WrapperA4 = styled.div`
  width: 100%;
  height: fit-content;
`;

export const WrapperPrint = styled.div`
  width: 100%;
  background: #ffffff;
`;

export const PageStyle = `
  @media print {
    body {
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
      width: 210mm;
      height: 297mm;
    }
    
    .break {
      break-inside: avoid;
    }

    .bill-content {
      break-inside: avoid;
      page-break-before: always;
    }

    .column-invitation {
      width: 100%;
    }
    
    .ant-table-container {
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
      border-left: 0px solid #9f9f9f !important;
    }
    
    table {
      border-top: 0px solid #9f9f9f !important;
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
    }
  
    .ant-table-tbody > tr > td {
      border-bottom: 1px solid #000000 !important;
      border-right: 1px solid #000000 !important;
  
      &:first-child {
        border-left: 1px solid #000000 !important;
      }
    }
  
    .ant-table-thead > tr > th {
      border-bottom: 1px solid #000000 !important;
      border-right: 1px solid #000000 !important;
      border-top: 1px solid #000000 !important;
      border-left: 1px solid #FFFFFF !important;
  
      font-weight: 600;
  
      &:first-child {
        border-top-left-radius: 0px !important;
        border-left: 1px solid #000000 !important;
      }
  
      &:last-child {
        border-top-right-radius: 0px !important;
      }
    }
    
    .ant-table-cell {
      padding: 6px 12px !important;
    }

    #signature {
      break-inside: avoid;
      page-break-before: always;
    }

    @page {
      -webkit-print-color-adjust: exact;
      margin: 25mm 25mm;
    }
  }
`;

export const K80PageStyle = `
  @media print {
    body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
    
    .break {
      break-inside: avoid;
    }
    .bill-content {
      break-inside: avoid;
      page-break-before: always;
    }
  }
`;

export const WrapperPopover = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: fit-content;
  height: fit-content;
`;

export const BillSection = styled.div`
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeaderBillSection = styled.div`
  width: 100%;
  padding: 12px 48px 12px 18px;

  border-bottom: 1px solid #efefef;
`;

export const BodyBillSection = styled.div`
  width: 100%;
  height: 100%;
  overflow: scroll;
  overflow-x: hidden;

  padding: 12px 12px 12px 18px;

  display: flex;
  justify-content: center;
`;

export const FooterBillSection = styled.div`
  width: 100%;
  padding: 12px 18px;

  border-top: 1px solid #efefef;
`;
